const buildAzFilter = (azFilter, mustFilters, azSortProperty) => {
  if (!azFilter) return;
  const filterValue = azFilter === '0' ? '[^a-zA-Z]' : azFilter;
  const azSortProp = `${azSortProperty}.keyword`;
  const azQuery = {
    regexp: {
      [azSortProp]: {
        value: `${filterValue}.*`,
        case_insensitive: true
      }
    }
  };
  mustFilters.push(azQuery);
};
export default buildAzFilter;
//# sourceMappingURL=build-az-filter.js.map